export const TASKS = {
    //* HR Tasks 
    COMPANY: 'Company',
    EMPLOYEE: 'Employee',
    EMPLMAINTENANCE: 'Employee-Maintenance Routines',
    TRAINING: 'Training',
    REPORTS: 'Reports',
    MONITORS: 'Monitors',
    ADMINTIME: 'Admin-Timesheets',
    UTILS: 'Utilities',
    ANALYTICS: 'Analytics',

    //* SS Tasks
    ALLEMPLOYEETASKS: 'My Tasks',
    UTILSADMIN: "Utilities-Admins",
    DELIGATE: 'MyTasks-DelegateTasks',
    ASSMMGMT: 'Assessment Management',

    //* General Parameters
    GENPARAM: 'General Parameters'
}

// TO FIND THESE GO TO SYSOPT AND SEARCH FOR DESCRIPTION BASED ON OLD HR BUTTON
export const TASK_OPTIONS = {

    //* HR Task Options   
    //* Company
    EDITCOMPANY: 'mnuCompanyProfile',
    BRANCHES: 'mnuBranches',
    ATTACHDOC: 'mnuAttachedDocuments',
    FUNCTIONS: 'mnuFunctions',
    EMPLCONTEXT: 'mnuEmploymentContext',
    STAFFLVLS: 'mnuStaffLevels',
    JOBTITLES: 'mnuJobTitles',
    LEAVETYPES: 'mnuLeaveTypes',
    LEAVESCHEMES: 'mnuLeaveSchemes',
    SALARYSCHEME: 'mnuSalaryComponent',
    STDRATES: "mnuStandardChargingRates",

    // * Admin Timesheet Pascal setting hours tought by proffessors  (School Related might be relevant for other schools in the future . G.C. School was not interested )
    ADMINTIME: 'mnuAdminTimesheets',

    //* Client Services, under employee for now but we should move to independant one this is under employees for now. 
    CLIENTSERVICE: 'mnuEmplClientService',

    //* Employee
    EMPLEDIT: 'mnuEmployeeProfile',
    REPORTSTO: 'mnuReportsTo',
    RATES: 'mnuChargingRates',
    SALARYREVIEWS: 'mnuEmplSalary',
    LEAVEANALYSIS: 'mnuLeaveAnalysis',
    ACADEMIC: 'mnuAcademicQualifications',
    ADDITIONAL: 'mnuEmplAdditionalQualifications',
    SPECIALDOC: 'mnuEmplSpecialDocs',
    EMPLWORKFLOWS: 'mnuEmplWorkflows',
    EXIT: 'mnuExitInterview',

    //* Training
    CATEGORIES: 'mnuTopics',
    SUBJECTS: 'Subjects',
    LMM: 'mnuLearningAndDevelopmentMethod',
    LM: 'mnuLearningAndDevelopment',
    TRAINEVALDOC: 'mnuTrnEvalDocuments',
    TRAINMATDOC: 'mnuTrnMatDocuments',
    TRAINEVENTS: 'mnuTrnEvent',
    TRAINPREQ: 'mnuTrnPrerequisites',
    TRAINMODATTEND: 'mnuTrnModAttend',
    TRAINMODULES: 'mnuTrnModules',
    TRAIN: 'mnuTraining',
    TRAINNEWCOURSE: 'mnuNewCourse',
    TRAINEDITCOURSE: 'mnuEditCourse',
    //* Employee Alerts
    EMPLALERTS: 'mnuEmplAlerts',
    //* Alerts
    ALERTS: 'mnuAlerts',
    //* Utils 
    LAA: 'mnuLeaveApplicationApproval',

    //* SS Tasks Options
    LEAVEAPPLICATIONS: 'LAHome',
    SURVEYS: 'SurvHome',
    ASSESSMENTS: 'AssmHome',
    ASSMMGMT: 'AssessmentManagement',
    SCHEDULER: 'Scheduler',
    LEAVEAPPROVAL: 'LAApproval',
    TIMESHEETHOME: 'TSHome',
    OUTOFPOCKETEXP: 'mnuTSexpenses',
    MYOUTOFPOCKETEXP: 'My Out-of-pocket expenses',
    TIMESHEETAPPROVAL: 'TSApproval',
    EMERGENCYCONTACT: 'Family Details',
    DOCUMENTS: 'My Documents',
    MYTEAM: 'MyTeam',
    TRAININGHOME: 'TrainingHome',
    MYEVENTS: 'MyEvents',
    MYREGISTRATIONS: 'My Registrations',
    FACILITATOR: 'Facilitator',

   // Analytics
   ANALYTICS_EMPLOYEES: 'mnuAnalyticsEmployees',
   ANALYTICS_LEAVES: 'mnuAnalyticsLeaves',

}